module.exports = {

    // Note: lang2: Two letter lang code like XX
    //       lang5: Five letter lang code like xx-YY

    jm: {
        register: {
            // LMI standard TCS
            // Params: jmLang5
            termsOfService: 'https://secure.logmein.com/policies/termsandconditions.aspx?lang={lang5}',

            // LMI standard PP
            // Params: jmLang5
            privacyPolicy: 'https://secure.logmein.com/policies/privacy.aspx?lang={lang5}',
        }
    },
    cls: {
        // Auto login user if "Keep me logged in" previously checked in this device and still not logged out
        // Params: clsAbsUrl, clsClientId, clsReturnUrl, lang5
        autoLogin: '{clsAbsUrl}auth/v1/autologin?client_id={clsClientId}&scope=openid%20offline_access&redirect_uri={clsReturnUrl}&ui_locales={lang5}'
    },
};


/** WEBPACK FOOTER **
 ** ./src/constants/redirect-url.js
 **/